<div class="mb-20 mct-flex mct-row mct-justify-between mct-items-start"  >
  <h4>
    {{ 'profiles.view.web-content.label' | translate | titlecase }}
  </h4>
  <a class="f-wb" [routerLink]="['/profile', profileId, 'web-content']">
    {{ 'profiles.view.web-content.manage-all' | translate | titlecase }}
    <i class="pi pi-angle-double-right"></i>
  </a>
</div>
<div *ngFor="let webContent of webContentRecords; last as isLast">
  <div class="web-content-row mct-flex mct-row mct-justify-between mct-items-center"  >
    <div class="mct-flex mct-col" >
      <a *ngIf="webContent.ContentFormat === 'Image' || webContent.ContentFormat === 'Document'" [href]="webContent.ContentUrl">
        {{ webContent.ContentTitle }}
      </a>
      <span *ngIf="webContent.ContentFormat !== 'Image' && webContent.ContentFormat !== 'Document'">
        {{ webContent.ContentTitle }}
      </span>
      <span class="light-text">{{ webContent.ContentFormat }}</span>
    </div>
    <div class="mct-flex mct-col mct-justify-center mct-items-end"  >
      <wl-ephemeral-content-swap #contentSwap>
        <a ngxClipboard [cbContent]="webContent.ContentUrl" (click)="contentSwap.show()">
          {{ 'profiles.view.web-content.copy-url' | translate }}
        </a>
        <div class="wl-ephemeral-content">
          {{ 'profiles.view.web-content.copied-to-clipboard' | translate | ucfirst }}
        </div>
      </wl-ephemeral-content-swap>
      <span class="light-text">{{ webContent.WebContentType?.ContentType }}</span>
    </div>
  </div>
  <hr [hidden]="isLast" />
</div>
